import styled from 'styled-components';

export const InfoPageUnderlinedText = styled.span`
  text-decoration: underline;
`;
